import {GeneratorRequest} from "./GeneratorRequest";

const nomApi = "ping"

export const PingRepository = {
    get : GeneratorRequest.get(nomApi, false),
}
